"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialShareIcon = void 0;
var _components = require("@ori-ui/components");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve - wrapped in a component */

const SocialShareIcon = ({
  kind,
  sharedUrl,
  onClick
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SocialIcon, {
  kind: kind,
  component: "a",
  href: (0, _utils.generateShareUrl)(kind, sharedUrl),
  target: "_blank",
  rel: "noreferrer",
  "aria-label": kind,
  onClick: onClick
});
exports.SocialShareIcon = SocialShareIcon;
